const exportToXls = async (
  data: any,
  fileName: string,
  sheetName?: string,
): Promise<boolean> => {
  try {
    //load XLSX library
    const XLSX = await import("xlsx");
    //create a new workbook
    const wb = XLSX.utils.book_new();
    //create a new worksheet
    const ws = XLSX.utils.json_to_sheet(data);
    //add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, sheetName || "Sheet1");
    //save the workbook to a file
    XLSX.writeFile(wb, fileName);
    return true;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export default exportToXls;
